import styles from './SpotDefault.module.scss';

export default function SpotDefault() {
	return (
		<svg
			width="320"
			height="220"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={styles.largeIllustration}
		>
			<path
				d="M72.214 128.437c14.588 11.928 34.185 22.27 56.783 29.003 54.68 16.291 106.222 5.278 115.124-24.598 8.901-29.876-28.209-67.303-82.889-83.594C106.553 32.956 55.01 43.969 46.108 73.846c-3.037 10.194-.717 21.266 5.829 32.079M30 73.521c11.226-37.68 76.23-51.569 145.19-31.023 47.777 14.235 84.918 41.264 99.494 69.056m-85.959 76.721c-17.112-.722-35.505-3.761-54.189-9.328C79.496 162.548 38.571 129.169 30 97.204m201.197 87.525c25.024-5.875 43.09-18.547 48.529-36.804M81.976 82.054c-4.27 14.328 13.528 32.277 39.751 40.09 26.223 7.812 50.942 2.531 55.211-11.797 4.269-14.328-13.529-32.277-39.752-40.09-26.223-7.813-50.942-2.532-55.21 11.797Zm-18.06-4.464c-6.442 21.623 20.416 48.709 59.989 60.5 39.573 11.79 76.875 3.82 83.317-17.802 6.443-21.623-20.415-48.71-59.988-60.5s-76.876-3.82-83.318 17.802Z"
				stroke="var(--coral-color-illustration-color-08, hsla(211,23%,74%,1))"
				strokeWidth="6"
				strokeLinecap="round"
			/>
			<circle
				cx="49.873"
				cy="66.361"
				r="8"
				fill="var(--coral-color-illustration-color-05, hsla(20,23%,97%,1))"
			/>
			<circle
				cx="280.75"
				cy="127.547"
				r="10"
				fill="var(--coral-color-illustration-color-05, hsla(20,23%,97%,1))"
			/>
			<circle
				cx="108.568"
				cy="168.869"
				r="10"
				fill="var(--coral-color-illustration-color-05, hsla(20,23%,97%,1))"
			/>
			<circle
				cx="202.627"
				cy="187.555"
				r="3"
				fill="var(--coral-color-illustration-color-08, hsla(211,23%,74%,1))"
			/>
			<circle
				cx="77.154"
				cy="171.156"
				r="3"
				fill="var(--coral-color-illustration-color-08, hsla(211,23%,74%,1))"
			/>
			<circle
				cx="66.824"
				cy="164.27"
				r="3"
				fill="var(--coral-color-illustration-color-08, hsla(211,23%,74%,1))"
			/>
			<circle
				cx="60.824"
				cy="118.27"
				r="3"
				fill="var(--coral-color-illustration-color-08, hsla(211,23%,74%,1))"
			/>
			<circle
				cx="217.551"
				cy="186.406"
				r="3"
				fill="var(--coral-color-illustration-color-08, hsla(211,23%,74%,1))"
			/>
			<path
				d="M249.073 114.633a5.755 5.755 0 0 1-1.219 4.342 5.766 5.766 0 0 1-3.98 2.129L89.058 139.961a7.728 7.728 0 0 1-5.168-1.328 7.714 7.714 0 0 1-3.072-4.358L60.792 52.573l-4.267-17.39-.31-1.27c-.891-3.547.917-11.554 6.741-12.754a.616.616 0 0 1 .205-.054l107.38-9.392 45.553-3.975a7.73 7.73 0 0 1 5.168 1.329 7.714 7.714 0 0 1 3.072 4.358l.505 2.071 24.097 98.292c.076.276.121.559.137.845Z"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<path
				d="M249.074 114.632a6.366 6.366 0 0 1-2.349.772L91.909 134.262a7.734 7.734 0 0 1-5.168-1.328 7.712 7.712 0 0 1-3.072-4.359L64.714 51.284l-5.336-21.758-.002-.042-.31-1.271a5.742 5.742 0 0 1 .502-4.322 5.753 5.753 0 0 1 3.389-2.733.616.616 0 0 1 .205-.055c.315-.1.638-.17.967-.206L172.042 7.744l46.903-5.705a7.73 7.73 0 0 1 5.168 1.328 7.712 7.712 0 0 1 3.071 4.359l.31 1.271 24.294 99.091a5.738 5.738 0 0 1-2.714 6.544Z"
				fill="var(--coral-color-illustration-color-07, hsla(192,33%,97%,1))"
			/>
			<path
				d="M224.84 15.495a6.322 6.322 0 0 1-2.408.818l-52.84 6.433L67.615 35.17a7.765 7.765 0 0 1-5.149-1.322 7.75 7.75 0 0 1-3.088-4.322l-.002-.042-.31-1.271a5.742 5.742 0 0 1 .502-4.322 5.753 5.753 0 0 1 3.389-2.733.616.616 0 0 1 .205-.055c.315-.1.638-.17.967-.206L172.042 7.744l46.903-5.705a7.718 7.718 0 0 1 8.24 5.686l.309 1.272a5.708 5.708 0 0 1-2.654 6.498ZM106.786 78.013a17.013 17.013 0 0 1-11.357-2.924 16.978 16.978 0 0 1-6.758-9.574l-7.095.885a25.21 25.21 0 0 0 10.038 14.21 25.261 25.261 0 0 0 16.861 4.336l-1.689-6.933Zm-8.703-35.456 1.708 6.91a17.053 17.053 0 0 1 11.35 2.934 17.025 17.025 0 0 1 6.765 9.564l7.096-.863a25.198 25.198 0 0 0-10.044-14.22 25.247 25.247 0 0 0-16.875-4.325Z"
				fill="var(--coral-color-illustration-color-01, hsla(252,43%,25%,1))"
			/>
			<path
				d="M125.002 61.102a18.914 18.914 0 0 1-8.708 21.337 18.965 18.965 0 0 1-7.809 2.506l-5.196-21.198 21.713-2.645Z"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<path
				d="m98.093 42.547 1.699 6.93a12.774 12.774 0 0 0-9.3 5.439 12.742 12.742 0 0 0-1.818 10.61l-7.098.865a18.903 18.903 0 0 1 2.692-15.77 18.937 18.937 0 0 1 13.825-8.074Z"
				fill="var(--coral-color-illustration-color-04, hsla(201,41%,64%,1))"
			/>
			<path
				d="m151.95 41.681-18.157 2.212-.883-3.597 18.159-2.212.881 3.597Z"
				fill="var(--coral-color-illustration-color-01, hsla(252,43%,25%,1))"
			/>
			<path
				d="m171.244 50.18-34.869 4.248-.883-3.597 34.869-4.249.883 3.597ZM167.839 58.402l-29.605 3.606-.882-3.597 29.606-3.606.881 3.597ZM174.961 65.337l-34.872 4.247-.88-3.597 34.869-4.247.883 3.597Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="m203.465 35.404-18.157 2.213-.882-3.597 18.159-2.211.88 3.595Z"
				fill="var(--coral-color-illustration-color-01, hsla(252,43%,25%,1))"
			/>
			<path
				d="m222.76 43.902-34.87 4.247-.882-3.598 34.869-4.246.883 3.597ZM219.352 52.123l-29.606 3.605-.881-3.594 29.607-3.609.88 3.598ZM226.477 59.064l-34.872 4.249-.88-3.597 34.869-4.25.883 3.598Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="m99.82 124.238-3.949.479-4.74-19.333 3.95-.482 4.739 19.336Z"
				fill="var(--coral-color-illustration-color-01, hsla(252,43%,25%,1))"
			/>
			<path
				d="m105.725 123.519-3.951.482-3.74-15.266 3.948-.479 3.743 15.263Z"
				fill="var(--coral-color-illustration-color-04, hsla(201,41%,64%,1))"
			/>
			<path
				d="m111.695 122.79-3.951.479-7.191-29.34 3.951-.482 7.191 29.343Z"
				fill="var(--coral-color-illustration-color-01, hsla(252,43%,25%,1))"
			/>
			<path
				d="m117.6 122.071-3.95.482-6.132-25.017 3.95-.481 6.132 25.016Z"
				fill="var(--coral-color-illustration-color-04, hsla(201,41%,64%,1))"
			/>
			<path
				d="m123.575 121.341-3.951.482-3.595-14.671 3.949-.482 3.597 14.671Z"
				fill="var(--coral-color-illustration-color-01, hsla(252,43%,25%,1))"
			/>
			<path
				d="m129.476 120.622-3.949.482-5.654-23.066 3.951-.481 5.652 23.065Z"
				fill="var(--coral-color-illustration-color-04, hsla(201,41%,64%,1))"
			/>
			<path
				d="m135.448 119.898-3.949.482-7.399-30.19 3.948-.481 7.4 30.189Z"
				fill="var(--coral-color-illustration-color-01, hsla(252,43%,25%,1))"
			/>
			<path
				d="m141.352 119.18-3.948.479-5.384-21.963 3.95-.481 5.382 21.965ZM159.483 92.59a5.818 5.818 0 0 1-5.08 7.333 7.766 7.766 0 0 1-5.188-1.332 7.748 7.748 0 0 1-3.087-4.373 5.818 5.818 0 0 1 5.079-7.333 7.77 7.77 0 0 1 5.189 1.333 7.752 7.752 0 0 1 3.087 4.373Z"
				fill="var(--coral-color-illustration-color-04, hsla(201,41%,64%,1))"
			/>
			<path
				d="m183.147 102.058-33.67 4.104-.735-2.994 33.671-4.104.734 2.994ZM177.836 108.716l-26.926 3.282-.734-2.992 26.928-3.281.732 2.991ZM186.012 113.736l-33.67 4.103-.735-2.994 33.671-4.101.734 2.992ZM211.395 86.269a5.818 5.818 0 0 1-5.079 7.333 7.769 7.769 0 0 1-5.189-1.333 7.752 7.752 0 0 1-3.087-4.373 5.82 5.82 0 0 1 5.08-7.333 7.767 7.767 0 0 1 5.188 1.333 7.753 7.753 0 0 1 3.087 4.373Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="m235.057 95.736-33.67 4.101-.735-2.992 33.673-4.103.732 2.994Z"
				fill="var(--coral-color-illustration-color-08, hsla(211,23%,74%,1))"
			/>
			<path
				d="m229.744 102.394-26.928 3.281-.734-2.994 26.928-3.279.734 2.992ZM237.92 107.412l-33.67 4.101-.734-2.992 33.672-4.103.732 2.994Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M204.846 47.943a10.605 10.605 0 0 0-4.369-6.272 16.134 16.134 0 0 0-5.919-2.528c-.862-.352-1.111-.054-.748.896 1.218.92 2.478 1.833 3.78 2.739-1.001.583-1.405 1.775-1.214 3.575a7.915 7.915 0 0 0 5.852 3.749l2.618-2.159Z"
				fill="var(--coral-color-illustration-skintone-02, hsla(21,34%,55%,1))"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M250.141 76.06a40.497 40.497 0 0 1-3.72 4.211 32.213 32.213 0 0 1-6.395 5.026c-9.214-.262-16.248-2.527-21.044-6.74a78.89 78.89 0 0 1-11.772-17.544c-1.832-3.427-3.692-7.233-5.581-11.416l3.284-1.83 20.086 22.483 25.142 5.81Z"
				fill="var(--coral-color-illustration-color-04, hsla(201,41%,64%,1))"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M246.422 80.272a32.21 32.21 0 0 1-6.394 5.025c-9.215-.261-16.249-2.527-21.045-6.739a78.891 78.891 0 0 1-11.772-17.544c6.743 9.76 14.562 16.353 19.678 16.527 5.755.204 16.51-1.016 19.533 2.73Z"
				fill="#000"
				fillOpacity=".1"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M243.165 211.015c-.03.959-.03 1.917-.059 2.876l-4.302-.029h-1.773c-.174-1.452-.349-2.905-.494-4.357-3.604-32.94-2.18-63.788-1.86-93.097l8.836.145 9.185.175c6.453 31.574-8.196 43.077-9.533 94.287Z"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M243.515 215.632c-1.453.146-2.848.291-4.186.407a94.425 94.425 0 0 1-12.382.349c-.465-3.573 7.557-3.312 9.447-6.943.058.029.087.058.145.058a7.158 7.158 0 0 0 1.773.727c1.52.529 3.14.708 4.738.523a1 1 0 0 1 .116.261 4.91 4.91 0 0 1 .349 4.618Z"
				fill="var(--coral-color-illustration-color-01, hsla(252,43%,25%,1))"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M239.475 172.44c-.436 12.2-2.093 27.595-1.163 37.791a39.72 39.72 0 0 0 .494 3.631c.134.735.308 1.463.523 2.178a94.251 94.251 0 0 1-12.382.349c-.465-3.573 7.557-3.312 9.447-6.942.058.029.087.058.145.058-3.604-32.94-2.18-63.788-1.86-93.097l8.836.145c3.052 23.616-3.546 42.061-4.04 55.887Z"
				fill="#000"
				fillOpacity=".1"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="m260.578 212.61-1.424.697-3.488 1.743c-.785-.988-1.54-1.975-2.267-2.934-22.265-28.524-33.543-44.761-35.026-53.679-.261-11.851 4.535-26.782 15.261-41.044 1.511-1.946 3.081-3.921 4.795-5.838l8.604 4.531c.436 11.561-1.947 25.475-14.01 40.87 5.93 8.83 15.58 26.636 26.044 51.936.494 1.22 1.017 2.469 1.511 3.718Z"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M262.002 213.453c-.439.463-.905.9-1.396 1.307a16.876 16.876 0 0 1-6.693 3.629c-2.478.685-5.08.795-7.607.321-.175-4.182 7.644-1.684 7.092-6.593v-.116a6.595 6.595 0 0 0 2.616-.756 9.644 9.644 0 0 0 2.994-2.382c.029.03.029.03.058.03a6.993 6.993 0 0 1 2.936 4.56Z"
				fill="var(--coral-color-illustration-color-01, hsla(252,43%,25%,1))"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M260.607 214.759a16.894 16.894 0 0 1-14.3 3.951c-.175-4.183 7.644-1.685 7.092-6.594-22.265-28.525-33.543-44.762-35.026-53.68-.261-11.851 4.535-26.781 15.261-41.043a5.93 5.93 0 0 1 1.191.464c7.529 3.951 3.488 8.54 3.488 8.54-12.469 18.91-18.05 27.915-9.795 42.09 7.586 13.071 17.352 34.857 27.497 42.757.787.65 1.634 1.224 2.529 1.714.21.104.414.22.61.349a5.285 5.285 0 0 1 1.453 1.452Z"
				fill="#000"
				fillOpacity=".1"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M255.604 128.171a44.646 44.646 0 0 1-9.563 3.573 24.69 24.69 0 0 1-22.207-4.357c6.744-11.939 5.087-19.781 4.592-30.035a93.167 93.167 0 0 1-.058-6.42c.095-2.743.357-5.479.785-8.19.088-.407.175-.814.262-1.192 3.488-13.042 20.899-12.316 23.806-3.05 4.505 11.822 5.299 28.379 2.383 49.671Z"
				fill="var(--coral-color-illustration-color-04, hsla(201,41%,64%,1))"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M247.243 73.823c-1.421 2.94-4.417 3.416-8.989 1.43 2.586-2.251 1.464-4.434 1.503-7.04l5.93-.4a5.81 5.81 0 0 0 1.556 6.01Z"
				fill="var(--coral-color-illustration-skintone-02, hsla(21,34%,55%,1))"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="m250.003 57.67-2.088 12.202c-5.585 2.743-9.125 3.055-10.621.935-1.901-3.118-1.835-8.474.198-16.067l12.511 2.93Z"
				fill="var(--coral-color-illustration-skintone-02, hsla(21,34%,55%,1))"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M240.334 61.16a10.096 10.096 0 0 1-9.969.22c-2.086-1.783-4.525-3.518-2.99-8.552 2.754-7.457 11.005-3.67 13.981-1.016a4.756 4.756 0 0 1 6.347 2.07c1.366-1.058 5.831 2.105 4.724 5.638-1.106 3.532-2.293 3.04-1.613 4.774 1.826 4.635-2.063 6.742-4.462 7.348a6.143 6.143 0 0 1-5.178-.37c-.845-2.966 1.257-3.745 2.357-4.716 1.1-.97.809-3.767-.62-2.906-1.668 1.917-2.44 3.72-3.77 2.06a4.975 4.975 0 0 0 1.193-4.55Z"
				fill="var(--coral-color-illustration-color-09, hsla(245,10%,23%,1))"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M233.625 90.067c-.134.3-.287.592-.458.874a18.095 18.095 0 0 1-2.206 2.88c-4.255 4.797-10.558 8.247-15.02 11.08-3.583 2.275-12.199 1.08-25.848-3.585a435.48 435.48 0 0 1-3.699-1.31l1.134-4.067 22.984.462 13.301-14.439a12.762 12.762 0 0 1 3.376-3.519c5.649-3.65 8.753 6.275 6.436 11.624Z"
				fill="var(--coral-color-illustration-color-04, hsla(201,41%,64%,1))"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M187.536 95.937c-2.964-3.595-4.798-2.735-3.951-1.176.722 1.329-2.836-3.159-4.04-1.67a4.971 4.971 0 0 0 1.309 6.404 8.556 8.556 0 0 0 5.549.492l1.133-4.05Z"
				fill="var(--coral-color-illustration-skintone-02, hsla(21,34%,55%,1))"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M246.044 131.744a24.689 24.689 0 0 1-22.207-4.357c6.744-11.939 5.029-20.799 4.535-31.052-4.745 3.55-11.848 9.283-14.307 9.283-4.099 1.103-13.114 0-27.321-5.734 15.846 2.73 20.874 2.522 28.024-.731a92.334 92.334 0 0 0 13.604-8.22c2.557-1.802 4.243-3.109 4.243-3.109s-.319 2.847-.523 6.74a67.38 67.38 0 0 0 .523 15.569c1.657 7.929-1.395 17.98 7.151 20.42 2.046.61 4.15 1.009 6.278 1.191Z"
				fill="#000"
				fillOpacity=".1"
			/>
		</svg>
	);
}
